import PropTypes from 'prop-types'
import React from 'react'

import SocialButton from './SocialButton'

import {
  FACEBOOK_LINK,
  TWITTER_LINK,
  LINKEDIN_LINK,
  INSTAGRAM_LINK
} from '../../config'

const FOLLOW_LINKS = {
  telegram: 'https://t.me/snipsair',
  twitter: TWITTER_LINK,
  facebook: FACEBOOK_LINK,
  instagram: INSTAGRAM_LINK,
  youtube: 'https://www.youtube.com/channel/UCOMl1ake_lFuYMy1Tna9ttw',
  linkedin: LINKEDIN_LINK
}

const SocialFollowButtons = ({ url, text, networks, analyticsExtra }) => (
  <div className='social-share-buttons'>
    {networks.map(network => {
      const followLink = FOLLOW_LINKS[network]
      if (!followLink) return null
      return (
        <SocialButton
          key={network}
          url={followLink}
          shareText={text}
          icon={network}
          forceAnchorElement={network === 'email'}
          target={network === 'email' ? undefined : '_blank'}
          analyticsExtra={analyticsExtra}
        />
      )
    })}
  </div>
)

SocialFollowButtons.propTypes = {
  networks: PropTypes.array.isRequired,
  // passed along to SocialButton component
  analyticsExtra: PropTypes.string
}

SocialFollowButtons.defaultProps = {
  networks: [
    'telegram',
    'twitter',
    'facebook',
    'instagram',
    'youtube',
    'linkedin'
  ]
}

export default SocialFollowButtons



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/SocialFollowButtons.js